// import Swal from "sweetalert2";
// import toast from "react-hot-toast";

// import { commonSwal } from "../../../components/swalAlert/swalAlert";
import { theme } from "../../../theme";
import { formatDateInJobStatsLog, formatMoney } from "../../../utils";
// import { jobPaymentRefund } from "../service";

const Transactions = ({ payments = [] }) => {
    const hasPayments = Array.isArray(payments) && payments.length > 0;

    // const refundPayment = (payment_id) => {
    //     commonSwal({
    //         notificationType: 'JOB_REFUND_PAYMENT',
    //         preConfirm: async (payment_value) => {
    //             if(isNaN(Number(payment_value))){
    //                 Swal.showValidationMessage('Please enter a valid numeric refund value.');
    //             }else{
    //                 const response = await jobPaymentRefund(payment_id, payment_value);
    //                 return response;
    //             }
    //         },
    //         isConfirmed: (result) => {
    //             if (result.isConfirmed) {
    //                 if(result.value.status === "Success"){
    //                     toast.success(result.value.message);
    //                 }else{
    //                     Swal.fire({
    //                         title: "ERROR",
    //                         text: result.value.message,
    //                         icon: "error"
    //                     });
    //                 }
    //             }
    //         }
    //     })
    // };

    return (
        <div className="card h-100 mb-4">
            <div className="card-header pb-0 px-3">
                <div className="row">
                    <div className="col-md-6">
                        <h6 className="mb-0">Transaction's</h6>
                    </div>
                </div>
            </div>

            <div className="card-body pt-4 p-3">
                {!hasPayments ? (
                    /* NO DATA VIEW */
                    <div className="text-center py-4">
                        <i className="material-icons text-secondary mb-2" style={{ fontSize: 40 }}>
                            receipt_long
                        </i>
                        <p className="text-sm text-secondary mb-0">
                            No transactions available
                        </p>
                    </div>
                ) : (
                    /* DATA LIST */
                    <ul className="list-group">
                        {payments.map((payment, index) => (
                            <li
                                key={index}
                                className="list-group-item border-0 d-flex align-items-center ps-0 mb-2 border-radius-lg"
                            >
                                {/* LEFT SIDE */}
                                <div className="d-flex align-items-center flex-grow-1">
                                    <div
                                        className={`btn btn-icon-only btn-rounded btn-outline-${theme.main} me-3 p-3 btn-sm d-flex align-items-center justify-content-center mb-0`}
                                    >
                                        <i className="material-icons text-lg">
                                            {payment?.payment_status_ref?.payment_status_ref_icon}
                                        </i>
                                    </div>

                                    <div className="d-flex flex-column">
                                        <h6 className="mb-1 text-dark text-sm">
                                            {payment?.payment_type_ref?.payment_type_ref_name}
                                        </h6>
                                        <span className="text-xs">
                                            {payment?.payment_status_ref?.payment_status_ref_name} (
                                            {payment?.payment_reference})
                                        </span>
                                        <span className="text-xs">
                                            {formatDateInJobStatsLog(payment?.payment_date_time)}
                                        </span>
                                    </div>
                                </div>

                                {/* RIGHT SIDE */}
                                <div className={`d-flex align-items-center text-${theme.main} text-gradient text-sm font-weight-bold`}>
                                    {/* {payment.payment_status === 2 && (
                                        <Tooltip title="Refund Payment" arrow placement="left">
                                            <IconButton 
                                                onClick={() => refundPayment(payment.payment_id)}
                                            >
                                                <HistoryIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )} */}
                                    {formatMoney(payment?.payment_amount)}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default Transactions;